<ng-container>
  <app-loader />
  <app-header class="fixed-header" />
  <app-messages />
  <div class="app-container overflow-auto flex" >
    <div class="sidebar" [ngClass]="{'show': isSidebarVisible}">
      <app-sidebar class="d-none d-lg-block" />

    </div>
    <button class="toggle-button" (click)="toggleSidebar()">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.2465 4.4545C12.6858 4.01517 13.3981 4.01517 13.8375 4.4545L20.5875 11.2045C21.0268 11.6438 21.0268 12.3562 20.5875 12.7955L13.8375 19.5455C13.3981 19.9848 12.6858 19.9848 12.2465 19.5455C11.8072 19.1062 11.8072 18.3938 12.2465 17.9545L18.201 12L12.2465 6.0455C11.8072 5.60616 11.8072 4.89384 12.2465 4.4545Z"
          fill="#002855"></path>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M4.04199 12C4.04199 11.3787 4.54567 10.875 5.16699 10.875H18.8545C19.4758 10.875 19.9795 11.3787 19.9795 12C19.9795 12.6213 19.4758 13.125 18.8545 13.125H5.16699C4.54567 13.125 4.04199 12.6213 4.04199 12Z"
          fill="#002855"></path>
      </svg>
    </button>
    <div style="width: 100%; min-height:450px;" (click)="collapse()">


      <router-outlet />

    </div>
  </div>
</ng-container>
